export default __webpack_public_path__ + "static/media/DIN-Light.2beef40d.ttf";